import { Http } from '@angular/http';

import { Injectable } from '@angular/core';

@Injectable()
export class StaticPageService {

  constructor(private http: Http) { }

  getFile(f: string) {
    f = f.toLowerCase();
    var timeStamp = new Date().getTime();
    f = f + '?tsp=' + timeStamp;
    // console.log(f);
    return this.http.get(f);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/static-page.service.ts